export default "__VITE_ASSET__D3Qc4a8r__"